import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { facetShape, SELECT_FILTER_CATEGORY_LABEL } from 'site-modules/shared/constants/inventory/filters-constants';
import { MODEL } from 'site-modules/shared/constants/allowed-inventory-request-params';
import { get } from 'lodash-es';
import { getCategoryGroupedOptions } from 'site-modules/shared/utils/inventory/get-category-grouped-options';

import { UsurpSelectFilter } from './usurp-select-filter';

export function UsurpSelectMakeModelFilter({ facet, facetType, make = null, ...props }) {
  let options = [];

  if (facetType === MODEL) {
    const { groups: groupedByMakeValues } = facet;
    options = get(groupedByMakeValues, make, []);
  } else {
    options = facet.values;
  }

  const optionsGrouped = useMemo(
    () => getCategoryGroupedOptions(options, SELECT_FILTER_CATEGORY_LABEL[facetType]),
    [facetType, options]
  );

  return <UsurpSelectFilter {...props} facet={{ ...facet, values: options }} optionsGrouped={optionsGrouped} />;
}

UsurpSelectMakeModelFilter.propTypes = {
  make: PropTypes.string,
  onUpdate: PropTypes.func.isRequired,
  facet: facetShape.isRequired,
  facetType: PropTypes.string.isRequired,
};
